import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Bannerfrom from "../../components/bannerfrom";

function Banner(props) {
  return (
    <div className="services_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={7} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Solutions">
                <h1>Innovative Solutions that Catalyze Transformation</h1>
              </div>
              <div className="banner_content_txt listing_flex">
                <p>
                  We are dedicated to delivering transformative software and app
                  development solutions that evolve and adapt to meet the unique
                  requirements of our clients, propelling their digital
                  evolution and catalyzing profound transformations.
                </p>
                <ul>
                  <li>User-Centered Design</li>
                  <li>Scalability and Flexibility</li>
                  <li>Security and Privacy</li>
                  <li>Innovation and Optimization</li>
                </ul>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto ms-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
